import { DefineHouseActions, EDefineHouseActions } from "@edp-store/actions/define-house.action";
import { IDefineHouseState, initialDefineHouseState } from "@edp-store/state/define-house.state";

export const defineHouseReducers = (state = initialDefineHouseState, action: DefineHouseActions): IDefineHouseState => {
    switch (action.type) {
        case EDefineHouseActions.SetServiceAnswers: {
            return {
                ...state,
                serviceAnswers: action.payload,
            };
        }

        case EDefineHouseActions.SetAnswers: {
            const newAnswers = action.payload;

            const filteredAnswers = state.answers?.filter(
                obj1 => !newAnswers?.some(obj2 => obj1.category === obj2.category && obj1.page === obj2.page)
            );

            return {
                ...state,
                answers: state.answers ? filteredAnswers.concat(newAnswers) : newAnswers,
            };
        }

        case EDefineHouseActions.ToggleEnergySourceSubstep: {
            const currentSubsteps = state.energySourceSubsteps || [];
            const index = currentSubsteps.indexOf(action.payload);

            if (!action.payload) {
                return {
                    ...state,
                    energySourceSubsteps: [],
                };
            }

            return {
                ...state,
                energySourceSubsteps:
                    index >= 0 ? currentSubsteps.filter(item => item !== action.payload) : [...currentSubsteps, action.payload],
            };
        }

        case EDefineHouseActions.SetActiveStep: {
            return {
                ...state,
                activeStepIndex: action.payload,
            };
        }

        case EDefineHouseActions.SetEquipmentActiveStep: {
            return {
                ...state,
                activeEquipmentStepIndex: action.payload,
            };
        }

        case EDefineHouseActions.SetHouseStatusMoonShot: {
            return {
                ...state,
                statusMoonShot: action.payload,
            };
        }

        case EDefineHouseActions.SetHouseEnergyComparison: {
            return {
                ...state,
                energyComparison: action.payload,
            };
        }

        case EDefineHouseActions.SetThermalInsulationActiveStep: {
            return {
                ...state,
                activeThermalInsulationStepIndex: action.payload,
            };
        }


        default:
            return state;
    }
};
